//---------------------------------------------------------------------
// React, MUI, and other third-party modules imports
//---------------------------------------------------------------------
import React, { useEffect, useRef } from 'react';
// import { useState, useEffect, useContext, useCallback } from 'react';
import { makeStyles, Grid, useTheme, useMediaQuery } from '@material-ui/core';
// import ThumbUpAltIcon from '@material-ui/icons/ThumbUpAlt';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
// import SimpleBar from 'simplebar-react';
import CloseIcon from '@material-ui/icons/Close';

//---------------------------------------------------------------------
// Common helpers and constants imports
//---------------------------------------------------------------------
import { logPageView } from '../../system/firebase';
// import { unsubscribeRealtimeUpdates } from '../../system/firebase';
// import { LayoutContext, AppContext } from '../../common/contexts';
import { setClassNameInDefns } from '../../common/definitionHelper';
import { getCopyrightText } from '../../common/textHelper';
import { PAGE_TITLE_RESOURCE_CENTER } from '../../common/constants';
import { AFITD_DOMAIN, PATH_RESOURCE_CENTER } from '../../system/constants';

//---------------------------------------------------------------------
// Page specific helpers and constants imports
//---------------------------------------------------------------------
import bannerImg from '../../images/ResourceCenter/Article 1 Main Image.jpeg';
import bannerLogo from '../../images/ResourceCenter/article1Logo/afitd_primary_logo-01.svg';
import clappingLogo from '../../images/ResourceCenter/article1Logo/Hands Clapping.png';
import penLogo from '../../images/ResourceCenter/article1Logo/Pen Icon.png';
import beLogo from '../../images/ResourceCenter/article1Logo/be.png';
import designLogo from '../../images/ResourceCenter/article1Logo/design.png';
import resumeLogo from '../../images/ResourceCenter/article1Logo/resume.png';
import { useHistory } from 'react-router-dom';

// import cardImg1 from '../../images/FAQ/Rectangle 202.png';
// import cardImg2 from '../../images/FAQ/Rectangle 2021.png';
// import cardImg3 from '../../images/FAQ/Rectangle 2022.png';
// import shareImg1 from '../../images/FAQ/Vector1.png';
// import shareImg2 from '../../images/FAQ/Vector2 (1).png';
// import shareImg3 from '../../images/FAQ/Vector3 (1).png';
// import shareImg4 from '../../images/FAQ/Ic_copy link.png';

//---------------------------------------------------------------------
// Common components imports
//---------------------------------------------------------------------
import AfitdPageHead from '../../common/elemental/AfitdPageHead';
// import AfitdTypography from '../../common/elemental/AfitdTypography';

//---------------------------------------------------------------------
// Page specific components imports
//---------------------------------------------------------------------
// import SubComponent1Example from './SubComponent1Example';

//---------------------------------------------------------------------
// Utilities (clsx, lodash, date-fns, etc.) imports
//---------------------------------------------------------------------
// import cx from 'clsx';
// import _get from 'lodash/get';

//---------------------------------------------------------------------
// CSS
//---------------------------------------------------------------------
const useStyles = makeStyles(theme => ({
    root: {
        // '&::-webkit-scrollbar-track': {
        //     borderRadius: '10px',
        //     background: 'none',
        // },
        // '&::-webkit-scrollbar': {
        //     width: '8px',
        //     backgroundColor: '#F5F5F5',
        // },
        // '&::-webkit-scrollbar-thumb': {
        //     borderRadius: '10px',
        //     backgroundColor: 'rgba(0,0,0,0.2)',
        // },
    },
    topText: { fontWeight: 700, fontSize: '16px', lineHeight: '19px', color: '#111E14', textAlign: 'center' },
    heading: {
        color: '#21898A',
        fontWeight: 700,
        fontSize: '42px',
        lineHeight: '52px',
        textAlign: 'center',
        maxWidth: '700px',
        margin: 'auto',
        [theme.breakpoints.down('sm')]: { fontSize: 26, lineHeight: '34px' },
    },
    bannerImg: { textAlign: 'center', marginTop: '45px', marginBottom: '40px' },
    paragraph: {
        fontSize: '20px',
        fontWeight: 400,
        lineHeight: '36px',
        maxWidth: '730px',
        margin: 'auto',
        [theme.breakpoints.down('sm')]: { fontSize: '18px', lineHeight: '32px' },
    },
    secondaryHeader: {
        color: '#21898A',
        fontSize: '26px',
        fontWeight: '700',
        lineHeight: '30px',
        marginTop: '70px',
        maxWidth: '730px',
        // margin: 'auto',
        marginBottom: '24px',
        [theme.breakpoints.down('sm')]: { fontSize: 22, lineHeight: '25px' },
    },
    social: { maxWidth: '730px', margin: 'auto', marginTop: '50px', display: 'flex', alignItems: 'center', marginBottom: '30px' },
    iconContainer: {
        width: '60px',
        height: '60px',
        borderRadius: '50%',
        backgroundColor: 'rgba(252, 130, 31, 0.13)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    socialText: { fontSize: '16px', fontWeight: 700, lineHeight: '19px', paddingLeft: '16px' },
    hr: { backgroundColor: '#F0F2F6', margin: 'auto', marginTop: 50, maxWidth: '840px' },
    navigations: { display: 'flex', justifyContent: 'space-between', maxWidth: '1100px', margin: 'auto', marginTop: '20px' },
    navigationIconContainer: {
        display: 'flex',
        width: '40px',
        height: '40px',
        borderRadius: '50%',
        border: '1px solid #D5D7DD',
        justifyContent: 'center',
        alignItems: 'center',
        '&:hover': { cursor: 'pointer' },
    },
    navigationText: { padding: '0 16px', fontSize: '20', width: '500', fontWeight: 'bold' },
    navigationButtonContainer: { display: 'flex', alignItems: 'center' },
    card: { width: '352px', borderRadius: '8px', border: '1px solid #D5D7DD', '&:hover': { cursor: 'pointer' } },
    cardContainer: { marginTop: '60px', marginBottom: 60 },
    cardContent: { marginBottom: '27px', marginLeft: '24px', marginRight: '20px', borderBottom: '20px solid #fafafc' },
    cardHeading: { fontSize: '26px', fontWeight: 'bold', lineHeight: '34px' },
    cardParagraph: { fontSize: '15px', fontWeight: 400, lineHeight: '24px' },
    cardSocial: { display: 'flex', alignItems: 'center', marginTop: '20px' },
    cardSocialText: { marginLeft: '9px', fontSize: '14px', lineHeight: '16px', fontWeight: 400 },
    cardSection: { display: 'flex', alignItems: 'flex-start', justifyContent: 'center' },
    dateTime: { marginBottom: 0, marginTop: '24px', fontSize: '14px', lineHeight: '16px', fontWeight: 400 },
    shareImageContainer: { textAlign: 'center', marginBottom: '16px', position: 'relative', '&:hover': { cursor: 'pointer' }, [theme.breakpoints.down('sm')]: { marginRight: 10 } },
    shareContainer: { display: 'flex', flexDirection: 'column', marginLeft: '-75px', [theme.breakpoints.down('sm')]: { flexDirection: 'row', marginLeft: 0, marginTop: 50 } },
    shareContainer2: { display: 'flex', flexDirection: 'column', position: 'absolute', top: 0, right: 25, [theme.breakpoints.only('md')]: { top: 360, right: 10 } },
    paragraphContainer: {
        // height: 500,
        [theme.breakpoints.only('md')]: { paddingRight: 30 },
        position: 'relative',
        // overflowY: 'scroll',
        // '&::-webkit-scrollbar-track': {
        //     borderRadius: '10px',
        //     background: 'none',
        // },
        // '&::-webkit-scrollbar': {
        //     width: '8px',
        //     backgroundColor: '#F5F5F5',
        // },
        // '&::-webkit-scrollbar-thumb': {
        //     borderRadius: '10px',
        //     backgroundColor: 'rgba(0,0,0,0.2)',
        // },
    },
    img: { width: '100%' },
    imgLogo: { display: 'flex', maxWidth: 275, zIndex: 1, marginTop: '-47px' },
    tableContainer: { border: '1px solid black', width: '100%', borderCollapse: 'collapse' },
    tableRow: { border: '1px solid black', padding: '5px 10px 10px 10px' },
    tableRowName: { border: '1px solid black', padding: '5px 10px 10px 10px', color: '#21898A', width: 170, fontWeight: 'bold' },
    skillTitle: { color: '#21898A', textDecoration: 'underline', fontWeight: 'bold' },
    skillContainer: { display: 'flex', justifyContent: 'space-around' },
    leftLogo: { width: 90, height: 90 },
    logoHeaderContainer: {
        display: 'flex',
        marginLeft: '121px',
        marginTop: '10px',
        marginBottom: '10px',
        alignItems: 'flex-end',
        [theme.breakpoints.down('md')]: { maxWidth: 730, margin: '0 auto' },
        [theme.breakpoints.down('sm')]: { marginLeft: 0 },
    },
    closeIconContainer: { display: 'flex', justifyContent: 'flex-end', marginTop: '-30px' },
    closeIcon: { color: '#A4A6A5' },
    backToTopContainer: { display: 'flex', justifyContent: 'flex-end', maxWidth: '905px' },
    backToTopText: {
        textDecoration: 'underline',
        color: '#1DA98E',
        fontStyle: 'italic',
        cursor: 'pointer',
        fontWeight: 'bold',
        fontSize: 18,
        [theme.breakpoints.down('sm')]: {
            fontSize: '14px',
        },
    },
    flexSpaceBetween: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        width: '100%',
    },
    copyRightText: {
        marginLeft: theme.spacing(20),
        fontSize: '18px',
        fontWeight: 'bold',
        [theme.breakpoints.down('sm')]: {
            marginLeft: '0px',
            fontSize: '14px',
            maxWidth: '220px',
        },
    },
}));

//---------------------------------------------------------------------
// Get definitions
//---------------------------------------------------------------------
const getDefns = params => {
    const { classes, handleCloseIcon } = params;

    const defns = {
        icon: { fontSize: '30px', color: '#FC821F', opacity: 1 },
        navIconLeft: { marginLeft: '10px' },
        navIconRight: { marginLeft: '3px' },
        cardContainer: { container: true, spacing: 5 },
        cardSection: { item: true, lg: 4, md: 6, sm: 12, xs: 12 },
        cardIcon: { color: 'rgba(17, 30, 20, 0.4)' },
        pageContent: { container: true },
        paragraphContainer: { item: true, lg: 12, md: 12, sm: 12, xs: 12 },
        shareContainer: { item: true, lg: 0, md: 0, sm: 12, xs: 12 },
        closeIcon: { onClick: handleCloseIcon },
    };

    // Automatically inject className for matching keys
    setClassNameInDefns(defns, classes);

    return defns;
};

//---------------------------------------------------------------------
// Helper functions
//---------------------------------------------------------------------

//---------------------------------------------------------------------
// Component
//---------------------------------------------------------------------
const Article = props => {
    //---------------------------------------------------------------------
    // From context and other hooks
    //---------------------------------------------------------------------
    const classes = useStyles();
    const theme = useTheme();
    // const matchesMd = useMediaQuery(theme.breakpoints.down('md'));
    const matchesSm = useMediaQuery(theme.breakpoints.down('sm'));
    const history = useHistory();
    const myRef = useRef(null);
    // const appContext = useContext(AppContext);
    // const { currentUser, userId, profileData, currentEmployer, employerId, lovs } = appContext;

    // const layoutContext = useContext(LayoutContext);
    // const { setSnackbarMessage, setSnackbarErrorMessage } = layoutContext;

    //---------------------------------------------------------------------
    // From props
    //---------------------------------------------------------------------
    // const { propExample } = props;

    //---------------------------------------------------------------------
    // Local states
    //---------------------------------------------------------------------
    // const [isDirty, setIsDirty] = useState(false);

    //---------------------------------------------------------------------
    // Derived
    //---------------------------------------------------------------------
    const pageTitle = `How To Create a Modern Resume Like a Boss | ${PAGE_TITLE_RESOURCE_CENTER}`;
    const pageTitleSeo = 'How to Create a Modern Resume';

    //---------------------------------------------------------------------
    // Side effects
    //---------------------------------------------------------------------
    useEffect(() => {
        logPageView(pageTitle);
    }, [pageTitle]);

    //---------------------------------------------------------------------
    // useCallback / Event handlers
    //---------------------------------------------------------------------
    const handleNextButton = () => {
        history.push('/resource-center/2');
    };
    const handleCloseIcon = () => {
        history.push('/resource-center');
    };
    // const handlePreviousButton = () => {
    //     history.push('/resource-center/4');
    // };

    //---------------------------------------------------------------------
    // Definitions
    //---------------------------------------------------------------------
    const defns = getDefns({ classes, props, handleCloseIcon });

    //---------------------------------------------------------------------
    // Render
    //---------------------------------------------------------------------
    return (
        <div {...defns.root}>
            <AfitdPageHead
                title={pageTitleSeo}
                description="How to write a strong resume professionally? We make the process easier by providing simple do’s and don’ts for crafting an effective resume."
                keywords="How to Create a Modern Resume, how to write a strong resume, how to write a professional resume"
                canonicalUrl={`https://${AFITD_DOMAIN}${PATH_RESOURCE_CENTER}/1`}
            />
            <div ref={myRef} />
            <p {...defns.topText}>5 min read</p>
            <div {...defns.closeIconContainer}>
                <CloseIcon {...defns.closeIcon} />
            </div>
            <h1 {...defns.heading}>How To Create a Modern Resume Like a Boss</h1>
            <div {...defns.navigations}>
                <div {...defns.navigationButtonContainer}>
                    <div {...defns.navigationIconContainer}>
                        <ArrowBackIosIcon style={{ ...defns.navIconLeft }} />
                    </div>
                    <span {...defns.navigationText}>Previous</span>
                </div>
                <div {...defns.navigationButtonContainer} onClick={handleNextButton}>
                    <span {...defns.navigationText}>Next</span>
                    <div {...defns.navigationIconContainer}>
                        <ArrowForwardIosIcon style={{ ...defns.navIconRight }} />
                    </div>
                </div>
            </div>

            <div {...defns.bannerImg}>
                <img {...defns.img} src={bannerImg} alt="" />
                <img {...defns.imgLogo} src={bannerLogo} alt="" />
            </div>

            <Grid {...defns.pageContent}>
                {matchesSm ? (
                    <>
                        <Grid {...defns.paragraphContainer}>
                            <div style={{ height: '100%' }} autoHide={false}>
                                <p {...defns.paragraph}>
                                    Let’s be real; creating a resume is probably not at the top of your favorite things todo list. It is, however, probably near the top of your,
                                    “adulting,” to-do list, especially if you’re in the market for your first, or next, job opportunity. At, “A Foot in the Door,” we challenge the
                                    common perception that creating a resume is daunting. It doesn’t have to be
                                    <br />
                                    <br />
                                    There is no universal standard for creating the perfect resume, and a quick google search will show you that even the experts don’t agree on all
                                    the rules that exist. That being said, there are a few general do’s and don’ts you may want to consider when composing your own resume
                                </p>
                                <div {...defns.logoHeaderContainer}>
                                    <img {...defns.leftLogo} src={clappingLogo} alt="" />
                                    <h2 {...defns.secondaryHeader}>Be Your own Hype Squad</h2>
                                </div>

                                <p {...defns.paragraph}>
                                    You may be thinking, especially if you’re new to the career game, that your ideal job is out of reach because you don’t have enough experience,
                                    skill level, education, etc. To that, we say, “Oh no, you didn’t!” Step one: Believe in yourself. Odds are you’ve acquired more skills than you
                                    realize.
                                    <br /> <br />
                                    Before getting started make a list of every skill you have, even if you think there’s no way it could be relevant. You never know when
                                    moonwalking or solving a Rubik’s cube might come in handy. Review this list repeatedly and remind yourself that you are more than ready to wow
                                    your future employer.
                                </p>
                                <div {...defns.logoHeaderContainer}>
                                    <img {...defns.leftLogo} src={penLogo} alt="" />
                                    <h2 {...defns.secondaryHeader}>Pre-Game</h2>
                                </div>

                                <p {...defns.paragraph}>
                                    The resume building process will be less stressful if you complete some minor prep work before you bust out your word processor of choice. List
                                    out the following: <br />
                                    <ul>
                                        <li>
                                            Every job you’ve ever had even back to babysitting and mowing lawns; include the timeframes you worked these jobs (month and date will
                                            suffice).
                                        </li>

                                        <li> Any education or formal training you’ve completed (include dates, the institution, your major/minor/certificate, etc.).</li>

                                        <li> Any awards or major achievements. </li>

                                        <li> Any formal organizations, clubs, or volunteer work.</li>

                                        <li> Keep that list of skills you made earlier handy.</li>
                                    </ul>
                                    <br />
                                    Next, marry the jobs and skills (a.k.a. match your skills to the jobs where you acquired and enhanced said skills). What skills did you learn
                                    from babysitting? Time-management, multitasking, conflict resolution, communication, building relationships, and the list goes on! More than
                                    likely you will not be listing all of these jobs on your actual resume but doing this prep work will 1) help you gauge the amount of experience
                                    you actually have, and 2) allow you to easily plug your information into your resume later.
                                </p>
                                <div {...defns.logoHeaderContainer}>
                                    <img {...defns.leftLogo} src={beLogo} alt="" />
                                    <h2 {...defns.secondaryHeader}>Be Bold</h2>
                                </div>

                                <p {...defns.paragraph}>
                                    A resume is more than a chronological listing of your experience and skills. It’s an introductory handshake (or elbow bump in these COVID-19
                                    times), a one-page billboard of all the ways in which you are awesome, and one might even say a small glimpse into the life you’ve lived so far.
                                    Professionalism is a must, but also ensure that what fills the page is a representation of who you are, and what you bring to the table.
                                    Employers receive anywhere from dozens to hundreds, to maybe even thousands, of resumes depending on the size of the company. If you don’t stand
                                    out, you will blend in. This is where having a solid design comes into play, and coincidentally, is next up on our list.
                                </p>
                                <div {...defns.logoHeaderContainer}>
                                    <img {...defns.leftLogo} src={designLogo} alt="" />
                                    <h2 {...defns.secondaryHeader}>Designing Your Resume</h2>
                                </div>

                                <p {...defns.paragraph}>
                                    You probably know that there are three types of resume’s: Chronological, Functional, and Combination. The type of resume you choose usually
                                    depends on where you are in your career (entry, junior, senior, etc.). For this post, we will focus on the Functional style which is commonly
                                    used by entry-level applicants, candidates seeking a career change, or those experiencing a work gap.
                                    <br />
                                    <br />
                                    You probably know that there are three types of resume’s: Chronological, Functional, and Combination. The type of resume you choose usually
                                    depends on where you are in your career (entry, junior, senior, etc.). For this post, we will focus on the Functional style which is commonly
                                    used by entry-level applicants, candidates seeking a career change, or those experiencing a work gap.
                                    <br />
                                    <br />
                                    Tips for Getting Started:
                                    <ul>
                                        <li>
                                            Start by building a general resume that can be used for multiple opportunities but leave room to customize based on specific application
                                            criteria.
                                        </li>

                                        <li>
                                            When designing, bear in mind that a typical recruiter will only spend 6-7 seconds (you read that right) skimming a resume. Identifying
                                            your top strengths and qualifications on the first page is crucial. Speaking of pages...
                                        </li>

                                        <li>
                                            This is widely debated but try to keep your resume to a single page. Not the easiest task, but if you’ve only got at most 7 seconds,
                                            that second page probably won’t be getting any eye time anyway.
                                        </li>

                                        <li>
                                            Don’t shy away from color. This isn’t 1991. Boring black and white resumes are out, eye catching design elements are in. We aren’t
                                            recommending you go too over-the-top here but adding a pop of color is both appropriate and encouraged.
                                        </li>
                                    </ul>
                                </p>
                                <div {...defns.logoHeaderContainer}>
                                    <img {...defns.leftLogo} src={resumeLogo} alt="" />
                                    <h2 {...defns.secondaryHeader}> Resume Content</h2>
                                </div>

                                <p {...defns.paragraph}>
                                    We’ve established that space is a precious commodity in the realm of resume’s so let’s begin with this table of the absolute musts:
                                    <table {...defns.tableContainer}>
                                        <tr>
                                            <td {...defns.tableRowName}>Name</td>
                                            <td {...defns.tableRow}>Make this baby big and bold, let them know you’ve arrived!</td>
                                        </tr>
                                        <tr>
                                            <td {...defns.tableRowName}>Contact Info </td>
                                            <td {...defns.tableRow}>Address, Phone Number, E-mail </td>
                                        </tr>
                                        <tr>
                                            <td {...defns.tableRowName}>Skill Highlights </td>
                                            <td {...defns.tableRow}>
                                                This list can include hard or soft skills. Start with your top 3-5 skills that would be relevant to any job that you know you rock
                                                at. This leaves room for 3-5 more skills that can be specific to the job you’re applying for. That skills list we made earlier is
                                                getting so much use!
                                                <div {...defns.skillContainer}>
                                                    <div>
                                                        <p>
                                                            <span {...defns.skillTitle}>Hard Skill Examples</span>
                                                            <br />
                                                            Software Development
                                                            <br />
                                                            Writing/Editing
                                                            <br />
                                                            Bi-Lingual
                                                            <br />
                                                            Coding
                                                        </p>
                                                    </div>
                                                    <div>
                                                        <p>
                                                            <span {...defns.skillTitle}>Soft Skill Examples</span>
                                                            <br />
                                                            Creative
                                                            <br />
                                                            Communication
                                                            <br />
                                                            Problem Solver
                                                            <br />
                                                            Leadership
                                                        </p>
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td {...defns.tableRowName}>Education</td>
                                            <td {...defns.tableRow}>
                                                Include any higher learning or certifications. High school is relevant if you’re new to the workforce, but if you’re 5+ years out of
                                                high school, and your one page is quickly filling up, it’s okay to omit that information (unless the employer specifically asks for
                                                it).
                                            </td>
                                        </tr>
                                        <tr>
                                            <td {...defns.tableRowName}>Experience</td>
                                            <td {...defns.tableRow}>
                                                Due to space, it’s wise to list only experience that is relevant to the position you’re applying for. Write in first person implied
                                                (like you’re talking to someone, but leave out the pronouns like, “I” and “me”). Third person resume writing is again, so 1990’s.
                                                Don’t do it. You can also nix articles (a, an, the) unless they are necessary to the sentence making sense. For each position you
                                                list include the following:
                                                <ul style={{ listStyle: 'none' }}>
                                                    <li>Your Job Title</li>

                                                    <li>Company Name, Company City/State</li>

                                                    <li>Dates You worked for that company (MM/YYYY-MM/YYYY) </li>

                                                    <li>
                                                        Concise bullet point summaries of your responsibilities for said job. Do your best to tie in the skills that you highlighted
                                                        (this helps to back up how you acquired these skills).
                                                    </li>
                                                </ul>
                                                If you have room, other elements you may consider adding: A link to your LinkedIn profile Up to 3 references. If there isn’t room to
                                                list out references be sure to include, “References available upon request,” somewhere on the page (usually toward the end of the
                                                resume).
                                            </td>
                                        </tr>
                                    </table>
                                    You now have a solid set of tools in your resume arsenal. This isn’t the, “be all, end all” of resume creation, but hopefully you’re feeling
                                    more confident about how to get started and are ready to document your amazing self for your soon-to-be new employer. Get ready for those doors
                                    to open!
                                </p>
                            </div>
                        </Grid>
                        {/* <Grid {...defns.shareContainer}>
                            <Tooltip title="Share the article on LinkedIn" placement="left">
                                <div {...defns.shareImageContainer}>
                                    <img src={shareImg1} alt="" />
                                </div>
                            </Tooltip>
                            <Tooltip title="Share the article on Twitter" placement="left">
                                <div {...defns.shareImageContainer}>
                                    <img src={shareImg2} alt="" />
                                </div>
                            </Tooltip>
                            <Tooltip title="Share the article on Facebook" placement="left">
                                <div {...defns.shareImageContainer}>
                                    <img src={shareImg3} alt="" />
                                </div>
                            </Tooltip>
                            <Tooltip title="Copy the article link" placement="left">
                                <div {...defns.shareImageContainer}>
                                    <img src={shareImg4} alt="" />
                                </div>
                            </Tooltip>
                        </Grid> */}
                    </>
                ) : (
                    <>
                        <Grid {...defns.paragraphContainer}>
                            <div style={{ height: '100%' }}>
                                <p {...defns.paragraph}>
                                    Let’s be real; creating a resume is probably not at the top of your favorite things todo list. It is, however, probably near the top of your,
                                    “adulting,” to-do list, especially if you’re in the market for your first, or next, job opportunity. At, “A Foot in the Door,” we challenge the
                                    common perception that creating a resume is daunting. It doesn’t have to be
                                    <br />
                                    <br />
                                    There is no universal standard for creating the perfect resume, and a quick google search will show you that even the experts don’t agree on all
                                    the rules that exist. That being said, there are a few general do’s and don’ts you may want to consider when composing your own resume
                                </p>
                                <div {...defns.logoHeaderContainer}>
                                    <img {...defns.leftLogo} src={clappingLogo} alt="" />
                                    <h2 {...defns.secondaryHeader}>Be Your own Hype Squad</h2>
                                </div>

                                <p {...defns.paragraph}>
                                    You may be thinking, especially if you’re new to the career game, that your ideal job is out of reach because you don’t have enough experience,
                                    skill level, education, etc. To that, we say, “Oh no, you didn’t!” Step one: Believe in yourself. Odds are you’ve acquired more skills than you
                                    realize.
                                    <br /> <br />
                                    Before getting started make a list of every skill you have, even if you think there’s no way it could be relevant. You never know when
                                    moonwalking or solving a Rubik’s cube might come in handy. Review this list repeatedly and remind yourself that you are more than ready to wow
                                    your future employer.
                                </p>
                                <div {...defns.logoHeaderContainer}>
                                    <img {...defns.leftLogo} src={penLogo} alt="" />
                                    <h2 {...defns.secondaryHeader}>Pre-Game</h2>
                                </div>

                                <p {...defns.paragraph}>
                                    The resume building process will be less stressful if you complete some minor prep work before you bust out your word processor of choice. List
                                    out the following: <br />
                                    <ul>
                                        <li>
                                            Every job you’ve ever had even back to babysitting and mowing lawns; include the timeframes you worked these jobs (month and date will
                                            suffice).
                                        </li>

                                        <li> Any education or formal training you’ve completed (include dates, the institution, your major/minor/certificate, etc.).</li>

                                        <li> Any awards or major achievements. </li>

                                        <li> Any formal organizations, clubs, or volunteer work.</li>

                                        <li> Keep that list of skills you made earlier handy.</li>
                                    </ul>
                                    <br />
                                    Next, marry the jobs and skills (a.k.a. match your skills to the jobs where you acquired and enhanced said skills). What skills did you learn
                                    from babysitting? Time-management, multitasking, conflict resolution, communication, building relationships, and the list goes on! More than
                                    likely you will not be listing all of these jobs on your actual resume but doing this prep work will 1) help you gauge the amount of experience
                                    you actually have, and 2) allow you to easily plug your information into your resume later.
                                </p>
                                <div {...defns.logoHeaderContainer}>
                                    <img {...defns.leftLogo} src={beLogo} alt="" />
                                    <h2 {...defns.secondaryHeader}>Be Bold</h2>
                                </div>

                                <p {...defns.paragraph}>
                                    A resume is more than a chronological listing of your experience and skills. It’s an introductory handshake (or elbow bump in these COVID-19
                                    times), a one-page billboard of all the ways in which you are awesome, and one might even say a small glimpse into the life you’ve lived so far.
                                    Professionalism is a must, but also ensure that what fills the page is a representation of who you are, and what you bring to the table.
                                    Employers receive anywhere from dozens to hundreds, to maybe even thousands, of resumes depending on the size of the company. If you don’t stand
                                    out, you will blend in. This is where having a solid design comes into play, and coincidentally, is next up on our list.
                                </p>
                                <div {...defns.logoHeaderContainer}>
                                    <img {...defns.leftLogo} src={designLogo} alt="" />
                                    <h2 {...defns.secondaryHeader}>Designing Your Resume</h2>
                                </div>

                                <p {...defns.paragraph}>
                                    You probably know that there are three types of resume’s: Chronological, Functional, and Combination. The type of resume you choose usually
                                    depends on where you are in your career (entry, junior, senior, etc.). For this post, we will focus on the Functional style which is commonly
                                    used by entry-level applicants, candidates seeking a career change, or those experiencing a work gap.
                                    <br />
                                    <br />
                                    You probably know that there are three types of resume’s: Chronological, Functional, and Combination. The type of resume you choose usually
                                    depends on where you are in your career (entry, junior, senior, etc.). For this post, we will focus on the Functional style which is commonly
                                    used by entry-level applicants, candidates seeking a career change, or those experiencing a work gap.
                                    <br />
                                    <br />
                                    Tips for Getting Started:
                                    <ul>
                                        <li>
                                            Start by building a general resume that can be used for multiple opportunities but leave room to customize based on specific application
                                            criteria.
                                        </li>

                                        <li>
                                            When designing, bear in mind that a typical recruiter will only spend 6-7 seconds (you read that right) skimming a resume. Identifying
                                            your top strengths and qualifications on the first page is crucial. Speaking of pages...
                                        </li>

                                        <li>
                                            This is widely debated but try to keep your resume to a single page. Not the easiest task, but if you’ve only got at most 7 seconds,
                                            that second page probably won’t be getting any eye time anyway.
                                        </li>

                                        <li>
                                            Don’t shy away from color. This isn’t 1991. Boring black and white resumes are out, eye catching design elements are in. We aren’t
                                            recommending you go too over-the-top here but adding a pop of color is both appropriate and encouraged.
                                        </li>
                                    </ul>
                                </p>
                                <div {...defns.logoHeaderContainer}>
                                    <img {...defns.leftLogo} src={resumeLogo} alt="" />
                                    <h2 {...defns.secondaryHeader}> Resume Content</h2>
                                </div>

                                <p {...defns.paragraph}>
                                    We’ve established that space is a precious commodity in the realm of resume’s so let’s begin with this table of the absolute musts:
                                    <table {...defns.tableContainer}>
                                        <tr>
                                            <td {...defns.tableRowName}>Name</td>
                                            <td {...defns.tableRow}>Make this baby big and bold, let them know you’ve arrived!</td>
                                        </tr>
                                        <tr>
                                            <td {...defns.tableRowName}>Contact Info </td>
                                            <td {...defns.tableRow}>Address, Phone Number, E-mail </td>
                                        </tr>
                                        <tr>
                                            <td {...defns.tableRowName}>Skill Highlights </td>
                                            <td {...defns.tableRow}>
                                                This list can include hard or soft skills. Start with your top 3-5 skills that would be relevant to any job that you know you rock
                                                at. This leaves room for 3-5 more skills that can be specific to the job you’re applying for. That skills list we made earlier is
                                                getting so much use!
                                                <div {...defns.skillContainer}>
                                                    <div>
                                                        <p>
                                                            <span {...defns.skillTitle}>Hard Skill Examples</span>
                                                            <br />
                                                            Software Development
                                                            <br />
                                                            Writing/Editing
                                                            <br />
                                                            Bi-Lingual
                                                            <br />
                                                            Coding
                                                        </p>
                                                    </div>
                                                    <div>
                                                        <p>
                                                            <span {...defns.skillTitle}>Soft Skill Examples</span>
                                                            <br />
                                                            Creative
                                                            <br />
                                                            Communication
                                                            <br />
                                                            Problem Solver
                                                            <br />
                                                            Leadership
                                                        </p>
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td {...defns.tableRowName}>Education</td>
                                            <td {...defns.tableRow}>
                                                Include any higher learning or certifications. High school is relevant if you’re new to the workforce, but if you’re 5+ years out of
                                                high school, and your one page is quickly filling up, it’s okay to omit that information (unless the employer specifically asks for
                                                it).
                                            </td>
                                        </tr>
                                        <tr>
                                            <td {...defns.tableRowName}>Experience</td>
                                            <td {...defns.tableRow}>
                                                Due to space, it’s wise to list only experience that is relevant to the position you’re applying for. Write in first person implied
                                                (like you’re talking to someone, but leave out the pronouns like, “I” and “me”). Third person resume writing is again, so 1990’s.
                                                Don’t do it. You can also nix articles (a, an, the) unless they are necessary to the sentence making sense. For each position you
                                                list include the following:
                                                <ul style={{ listStyle: 'none' }}>
                                                    <li>Your Job Title</li>

                                                    <li>Company Name, Company City/State</li>

                                                    <li>Dates You worked for that company (MM/YYYY-MM/YYYY) </li>

                                                    <li>
                                                        Concise bullet point summaries of your responsibilities for said job. Do your best to tie in the skills that you highlighted
                                                        (this helps to back up how you acquired these skills).
                                                    </li>
                                                </ul>
                                                If you have room, other elements you may consider adding: A link to your LinkedIn profile Up to 3 references. If there isn’t room to
                                                list out references be sure to include, “References available upon request,” somewhere on the page (usually toward the end of the
                                                resume).
                                            </td>
                                        </tr>
                                    </table>
                                    You now have a solid set of tools in your resume arsenal. This isn’t the, “be all, end all” of resume creation, but hopefully you’re feeling
                                    more confident about how to get started and are ready to document your amazing self for your soon-to-be new employer. Get ready for those doors
                                    to open!
                                </p>
                                {/* <div {...defns.shareContainer2}>
                                <Tooltip title="Share the article on LinkedIn" placement="left">
                                    <div {...defns.shareImageContainer}>
                                        <img src={shareImg1} alt="" />
                                    </div>
                                </Tooltip>
                                <Tooltip title="Share the article on Twitter" placement="left">
                                    <div {...defns.shareImageContainer}>
                                        <img src={shareImg2} alt="" />
                                    </div>
                                </Tooltip>
                                <Tooltip title="Share the article on Facebook" placement="left">
                                    <div {...defns.shareImageContainer}>
                                        <img src={shareImg3} alt="" />
                                    </div>
                                </Tooltip>
                                <Tooltip title="Copy the article link" placement="left">
                                    <div {...defns.shareImageContainer}>
                                        <img src={shareImg4} alt="" />
                                    </div>
                                </Tooltip>
                            </div> */}
                            </div>
                        </Grid>
                    </>
                )}
            </Grid>

            <hr {...defns.hr} />
            <div {...defns.backToTopContainer}>
                <div {...defns.flexSpaceBetween}>
                    <div {...defns.copyRightText}>{getCopyrightText()}</div>
                    <p
                        {...defns.backToTopText}
                        onClick={() => {
                            setTimeout(() => {
                                myRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
                            }, 100);
                        }}
                    >
                        Back to the top
                    </p>
                </div>
            </div>

            {/* <h2 {...defns.heading}>Related Content</h2>
            <Grid {...defns.cardContainer}>
                <Grid {...defns.cardSection}>
                    <div {...defns.card}>
                        <div {...defns.imageContainer}>
                            <img {...defns.img} src={cardImg1} alt="" />
                        </div>
                        <div {...defns.cardContent}>
                            <p {...defns.dateTime}>2 min read</p>
                            <h3 {...defns.cardHeading}>Remote Workstations for the Discerning Artists</h3>
                            <p {...defns.cardParagraph}>
                                Netflix is poised to become the world’s most prolific producer of visual effects and original animated content. To meet that demand, we need to
                                attract the world’s best artistic talent.{' '}
                            </p>
                        </div>
                    </div>
                </Grid>
                <Grid {...defns.cardSection}>
                    <div {...defns.card}>
                        <div {...defns.imageContainer}>
                            <img {...defns.img} src={cardImg2} alt="" />
                        </div>
                        <div {...defns.cardContent}>
                            <p {...defns.dateTime}>2 min read</p>
                            <h3 {...defns.cardHeading}>Working Remotely: A Complete Guide to Turn You Into a Pro</h3>
                            <p {...defns.cardParagraph}>
                                Working remotely is more difficult in practice than in theory. Turn to this guide with actionable advice from veteran remote workers on how to
                                handle challenges that are
                            </p>
                        </div>
                    </div>
                </Grid>
                {matchesMd ? (
                    <></>
                ) : (
                    <Grid {...defns.cardSection}>
                        <div {...defns.card}>
                            <div {...defns.imageContainer}>
                                <img {...defns.img} src={cardImg3} alt="" />
                            </div>
                            <div {...defns.cardContent}>
                                <p {...defns.dateTime}>2 min read</p>
                                <h3 {...defns.cardHeading}>Brent Potts Joins Airbnb as Vice President of Community Support</h3>
                                <p {...defns.cardParagraph}>
                                    Today we are excited to announce that Brent Potts has joined Airbnb as Vice President of Community Support. Lorem ipsum dolor sit amet.
                                </p>
                            </div>
                        </div>
                    </Grid>
                )}
            </Grid> */}
        </div>
    );
};

export default Article;
